var exports = {
  "vK": "ReportFlowBanner.module__banner___QkJrX0",
  "Kk": "ReportFlowBanner.module__icon___QkJrX0",
  "Qq": "ReportFlowBanner.module__text___QkJrX0",
};

module.exports = exports;
